var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShoppingBasketFill = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M19.078 12H4.923a.3.3 0 0 0-.299.331L5.24 18.3c.16 1.53.75 2.7 2.99 2.7h7.56c2.2 0 2.84-1.17 2.98-2.7l.606-5.97a.3.3 0 0 0-.298-.33M21 9a2 2 0 0 1-2 2H5a2 2 0 0 1 0-4h1.728l2.649-4.388a.749.749 0 1 1 1.283.776L8.479 7h7.051l-2.156-3.616a.75.75 0 1 1 1.289-.767l2.614 4.384H19A2 2 0 0 1 21 9"
})));
export default SvgShoppingBasketFill;